<template>
  <UtilityText :text="cancelSorry" />
</template>

<script setup lang="ts">
const { t } = useI18n()
const client = useRuntimeConfig().public.client
const clientMap = useRuntimeConfig().public.clientMapping as ClientMapping

const cancelSorry = ref(t('dbc-cancel-contract-we-are-sorry'))
cancelSorry.value = cancelSorry.value!.replace(
  '[placeholder]',
  clientMap[client]!
)
</script>
